module.exports = __webpack_public_path__ + "img/NW07.ae9046ec.jpg";